import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {firstValueFrom, map, Observable, of} from "rxjs";
import {CustomMessageService, LocalStorageService, ResponseHttpSuccess, UtilService, OriginMessageError} from "library";
import {AuthService} from "projects/store/src/app/services/api/v1/auth.service";
import {WorkflowStep, Workflow} from "projects/store/src/app/interfaces";
import { SalesWorkflowSteps, SalesWorkflow, RequestStatus, LocalStorageKey,SalesWorkflowRequiresAuthentication } from "projects/store/src/app/enums";
import {environment} from "projects/store/src/environments/environment";
import {PathNavigationService} from 'projects/store/src/app/services/api/v1/path-navigation.service';
import {RequestService} from 'projects/store/src/app/services/api/v1/request.service';
import {MacroFlowService} from 'projects/store/src/app/services/api/v1/macro-flow.service';
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class SalesWorkflowService {
  url: string = environment.salesAPIURL;
  steps!: WorkflowStep[];
  currentStep!: WorkflowStep;
  workflow!: Workflow;
  workflows!: Workflow[];
  urlSteps: {code: string, path: string}[] = [
    {code: SalesWorkflowSteps['introduction'], path: 'introduccion'},
    {code: SalesWorkflowSteps['simulator'], path: 'simulador'},
    {code: SalesWorkflowSteps['pre-client-verification'], path: 'pre-verificacion-cliente'},
    {code: SalesWorkflowSteps['client-verification'], path: 'verificacion-cliente'},
    {code: SalesWorkflowSteps['client-identification'], path: 'identificacion-cliente'},
    {code: SalesWorkflowSteps['client-identification-express'], path: 'identificacion-cliente-express'},
    {code: SalesWorkflowSteps['take-picture'], path: 'tomar-fotografia'},
    {code: SalesWorkflowSteps['identity-document-photo'], path: 'tomar-fotografia-documento-adicional'},
    {code: SalesWorkflowSteps['credit-setup'], path: 'configuracion-credito'},
    {code: SalesWorkflowSteps['credit-bureau'], path: 'autorizacion-credito'},
    {code: SalesWorkflowSteps['select-category'], path: 'categorias'},
    {code: SalesWorkflowSteps['select-product'], path: 'productos'},
    {code: SalesWorkflowSteps['select-store'], path: 'tiendas'},
    {code: SalesWorkflowSteps['select-quota'], path: 'cuotas'},
    {code: SalesWorkflowSteps['validate-geolocalization'], path: 'validar-geolocalizacion'},
    {code: SalesWorkflowSteps['credit-summary'], path: 'resumen-credito'},
    {code: SalesWorkflowSteps['accept-credit-conditions'], path: 'aceptar-condiciones-credito'},
    {code: SalesWorkflowSteps['point-of-sales'], path: 'punto-de-venta'},
    {code: SalesWorkflowSteps['review-contract'], path: 'revisar-contrato'},
    {code: SalesWorkflowSteps['signing-contract'], path: 'firma-contrato'},
    {code: SalesWorkflowSteps['advanced-contract-signing'], path: 'firma-contrato-avanzada'},
    {code: SalesWorkflowSteps['phone-app-instalation'], path: 'instalar-app-telefono'},
    {code: SalesWorkflowSteps['phone-enrollment'], path: 'enrolar-telefono'},
    {code: SalesWorkflowSteps['phone-register'], path: 'registrar-telefono'},
    {code: SalesWorkflowSteps['payment-information'], path: 'informacion-desembolso'},
    {code: SalesWorkflowSteps['final-message-bank-transfer'], path: 'mensaje-final-transferencia-bancaria'},
    {code: SalesWorkflowSteps['final-message-luki'], path: 'mensaje-final-luki'},
    {code: SalesWorkflowSteps['final-message-store'], path: 'mensaje-final-tienda'},
    {code: SalesWorkflowSteps['additional-customer-information'], path: 'informacion-adicional-cliente'},
    {code: SalesWorkflowSteps['final-instructions-client'], path: 'instrucciones-finales-cliente'},
    {code: SalesWorkflowSteps['not-approved-request'], path: 'solicitud-no-aprobada'},
    {code: SalesWorkflowSteps['update-client-information'], path: 'actualizar-informacion-cliente'},
    {code: SalesWorkflowSteps['update-product-information'], path: 'actualizar-informacion-producto'},
    {code: SalesWorkflowSteps['create-request'], path: 'crear-solicitud'},
    {code: SalesWorkflowSteps['express-bureau'], path: 'buro-express'},
    {code: SalesWorkflowSteps['email-validation'], path: 'validacion-email'},
    {code: SalesWorkflowSteps['store-view-by-category'], path: 'visualizacion-tienda'},
    {code: SalesWorkflowSteps['facematch-verification'], path: 'verificacion-facematch'},
    {code: SalesWorkflowSteps['select-conditions'], path: 'seleccionar-condiciones'},
    {code: SalesWorkflowSteps['search-request'], path: 'buscar-solicitud'},
    {code: SalesWorkflowSteps['registered-application'], path: 'solicitud-registrada'}
  ]

  constructor(private http: HttpClient,
              private authService: AuthService,
              private customMessageService: CustomMessageService,
              private utilService: UtilService,
              private pathNavigationService: PathNavigationService,
              private localStorageService: LocalStorageService,
              private requestService: RequestService,
              private macroFlowService: MacroFlowService,
              private router: Router) { }

  getList() {
    return this.http.get(`${this.url}sales-workflow/flows`, this.authService.getHttpOptionsBearer())
      .pipe(map((resp: any) => {
        this.workflows = resp.body.data.list;
        return resp as ResponseHttpSuccess;
      }));
  }

  getStepsByFlowId(id: string, categoryId: string | undefined) {
    let options;
    let params: {category_id?: string, store_id?: string} = {};
    let data = this.localStorageService.get(LocalStorageKey.data)
    if(categoryId !== undefined) {
      params.category_id = categoryId;
    }
    if(data?.store.id !== undefined) {
      params.store_id = data?.store.id;
    }
    if (Object.keys(params).length > 0) {
      options = {...this.authService.getHttpOptionsBearer(), params }
    }else{
      options = this.authService.getHttpOptionsBearer()
    }
    return this.http.get(`${this.url}sales-workflow/flow/${id}/steps`, options)
      .pipe(map((resp: any) => {
        this.steps = resp.body.data.list.sort((a: any, b: any) => a.order - b.order);
        return resp as ResponseHttpSuccess
      }));
  }

  getListStepsByFlowId(id: string, categoryId: string | undefined) {
    let options;
    let params: {category_id?: string, store_id?: string} = {};
    let data = this.localStorageService.get(LocalStorageKey.data)
    if(categoryId !== undefined) {
      params.category_id = categoryId;
    }
    if(data?.store.id !== undefined) {
      params.store_id = data?.store.id;
    }
    if (Object.keys(params).length > 0) {
      options = {...this.authService.getHttpOptionsBearer(), params }
    }else{
      options = this.authService.getHttpOptionsBearer()
    }
    return this.http.get(`${this.url}sales-workflow/flow/${id}/steps`, options)
      .pipe(map((resp: any) => {
        resp.body.data.list.sort((a: any, b: any) => a.order - b.order);
        return resp as ResponseHttpSuccess
      }));
  }

  get(id: string) {
    return this.http.get(`${this.url}sales-workflow/category/${id}/steps`, this.authService.getHttpOptionsBearer())
      .pipe(map((resp: any) => {
        this.steps = resp.body.data.list.sort((a: any, b: any) => a.order - b.order);
        return resp as ResponseHttpSuccess
      }));
  }

  getAdditionalDataFields(categoryStepId: string) {
    return this.http.get(`${this.url}sales-workflow/category-step/${categoryStepId}/additional-data`, this.authService.getHttpOptionsBearer())
      .pipe(map(resp => resp as ResponseHttpSuccess));
  }

  getStepByName(stepName: string) {
    let index = this.urlSteps.findIndex(row => row.path === stepName);
    let search: WorkflowStep[] = this.steps.filter((row:WorkflowStep) => row.code == this.urlSteps[index]?.code);
    if(search.length == 0) {
      return {} as WorkflowStep;
    }

    if(search.length > 1){
      this.customMessageService.responseNoticeHandler({ message: 'Existe mas de 1 paso: ' + stepName}, OriginMessageError.FRONTEND);
      this.utilService.disablePageLoading();
    }
    return search[0];
  }

  getStepByCode(stepCode: string) {
    let search: WorkflowStep[] = this.steps.filter((row:WorkflowStep) => row.code == stepCode);
    if(search.length == 1) {
      return search[0];
    }else{
      throw new Error('Code no encontrado: ' + stepCode);
    }
  }

  getStepOfStepsByPosition(pos: number) {
    return this.steps[pos] ?? null;
  }

  getUrlStepByCode(stepCode: string) {
    let search = this.urlSteps.filter(row => row.code === stepCode);
    if(search.length == 1) {
      return search[0];
    }else{
      throw new Error('Code no encontrado: ' + stepCode);
    }
  }

  getUrlStepByPath(path: string) {
    let search = this.urlSteps.filter(row => row.path === path);
    if(search.length == 1) {
      return search[0];
    }else{
      throw new Error('Code no encontrado: ' + path);
    }
  }

  buildUrl(data: { flowCode: string, categoryCode?: string, requestId?: string, path: string}) {
    let url = `ventas/${data.flowCode}`
    if(data.categoryCode !== undefined) {
      url+= `/categoria/${data.categoryCode}`;
    }
    if(data.requestId !== undefined) {
      url+= `/solicitud/${data.requestId}`;
    }
    url+= `/${data.path}`;
    return url;
  }

  getCategoryRequestUrl(categoryCode: string, requestId: string | null, path: string) {
    if(requestId === null){
      return `ventas/categoria/${categoryCode}/solicitud/{requestId}/${path}`
    }else{
      return `ventas/categoria/${categoryCode}/solicitud/${requestId}/${path}`
    }
  }

  getCategoryUrl(flowCode:string,categoryCode: string, path: string) {
    return `ventas/${flowCode}/categoria/${categoryCode}/${path}`
  }

  getRequestUrl(requestId: string | null, path: string) {
    if(requestId === null) {
      return `ventas/solicitud/{requestId}/${path}`
    }else{
      return `ventas/solicitud/${requestId}/${path}`
    }
  }

  getErrorNotApprovedRequestUrl() {
    return `ventas/${this.workflow.code}/error/solicitud-no-aprobada`
  }

  getErrorRetryRequest() {
    return `ventas/${this.workflow.code}/error/solicitud-reintentar`
  }

  private getCategoryCodeByLocation(): string {
    const match = window.location.pathname.match(/categoria\/([^\/]+)/);
    return match ? match[1] : '';
  }

  getInitialPath(flowCode?: string): { routerLink: string; queryParams?: any } | undefined  {
    const code = flowCode ?? this.utilService.getFlowCodeByLocation();

    if(this.authService.isAuthenticated()) {
      return {routerLink: `/inicio`};
    }

    const firstFlow = this.macroFlowService.getFirstFlowInMacro(code);
    if (!firstFlow) return undefined;

    let routerLink = `/ventas/${firstFlow}`;
    if (firstFlow === code) {
      const categoryCode = this.getCategoryCodeByLocation();
      if (categoryCode) {
        routerLink += `/categoria/${categoryCode}`;
      }
    }

    const startToken = this.localStorageService.get(LocalStorageKey.startToken);
    if (startToken) {
      return { routerLink, queryParams: { start_token: btoa(JSON.stringify(startToken)) } };
    }

    return { routerLink };
  }

  getAuthenticationErrorPath(flowCode: string): { routerLink: string } | undefined {
    const requiresAuthentication = SalesWorkflowRequiresAuthentication[flowCode as SalesWorkflow];

    if (requiresAuthentication) {
      return {routerLink: '/inicio'};
    }

    return this.getInitialPath(flowCode);
  }

  navigateToInitial(flowCode?: string): void {
    const code = flowCode ?? this.utilService.getFlowCodeByLocation();
    this.resetState();

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/inicio']);
      return;
    }

    if ([SalesWorkflow['app-krdya-cliente'], SalesWorkflow['app-krdya-kredicash']].includes(code as any)) {
      this.pathNavigationService.navigateToExitAppKrdya();
      return;
    }

    const result = this.getInitialPath(flowCode);
    if (result) {
      this.router.navigate([result.routerLink], { queryParams: result.queryParams });
    }
  }

  canCancelRequest(): boolean {
    return (this.requestService.request['agreement'].status || '').toUpperCase() === (RequestStatus['INICIADO'] || '').toUpperCase();
  }

  getFlowByCode(code: string) {
    return this.workflows.find(
      (row: any) => row.code === code
    );
  }

  async checkAndSetNextWorkflowStep(): Promise<boolean | { currentCategoryStepId: string; pathNext: string, flowCode: string, categoryCode: string } | null | string> {

    const currentCategoryStepId = this.requestService.request['current_category_step_id'];

    if(currentCategoryStepId === null) return false;

    const status = this.requestService.request['status'];
    const response: any = await firstValueFrom(this.requestService.getInformationByCategoryStepId(currentCategoryStepId));
    const stepByCategoryStepId = response.body?.data?? null;

    if (!stepByCategoryStepId) return false;

    const currentFlowCode = stepByCategoryStepId.flow.code;
    const currentStepCode = stepByCategoryStepId.code;
    const categoryCode = stepByCategoryStepId.category?.code;

    // Obtener todos los pasos del flujo actual para verificar si es el último
    const currentFlowStepsResponse: any = await firstValueFrom(this.getListStepsByFlowId(stepByCategoryStepId.flow.id, this.requestService.categoryId));
    const currentFlowSteps: WorkflowStep[] = currentFlowStepsResponse.body?.data?.list ?? [];

    const isLastStep = (currentFlowSteps.length > 0 && currentFlowSteps[currentFlowSteps.length - 1].code === currentStepCode) || stepByCategoryStepId.order >= 1000;

    // Si no es el último paso, retornamos el paso actual para que continúe ahí
    if (!isLastStep) {

      // Mantener lógica específica para autogestion-cliente incompleto si es necesario
      if (currentFlowCode === this.macroFlowService.getAutogestionClienteFlow() &&
          currentStepCode !== SalesWorkflowSteps['final-instructions-client']) {
        return "autogestion-cliente-incompleto";
        }

        return {
          currentCategoryStepId,
        pathNext: this.getUrlStepByCode(currentStepCode).path,
        flowCode: currentFlowCode,
        categoryCode: categoryCode
      };
        }

    // Si es el último paso, buscamos el siguiente flujo en el macro flujo
    const nextFlowCode = this.macroFlowService.getNextFlowInMacro(currentFlowCode);

    if (nextFlowCode && nextFlowCode !== currentFlowCode) {
      const nextFlow = this.getFlowByCode(nextFlowCode);

      if (nextFlow?.id) {
        const nextStepsResponse: any = await firstValueFrom(this.getListStepsByFlowId(nextFlow.id, this.requestService.categoryId));
        const nextSteps: WorkflowStep[] = nextStepsResponse.body?.data?.list ?? [];

        if (nextSteps.length > 0) {
          return {
            currentCategoryStepId : nextSteps[0].category_step_id,
            pathNext : this.getUrlStepByCode(nextSteps[0].code).path,
            flowCode: nextFlowCode,
            categoryCode: categoryCode
          };
        }
          }
    }

    // Si era el último paso pero no hay siguiente flujo o no tiene pasos,
    // verificamos si hay una lógica de salida específica (como el caso de Aprobado que ya existía)
    if (currentStepCode === SalesWorkflowSteps['final-instructions-client'] && status === RequestStatus['Aprobado']) {
       // Esto ya debería haber sido manejado por la lógica de "nextFlow" si macroFlowService está bien configurado,
       // pero lo dejamos como fallback si es un caso especial fuera de la macro-secuencia normal o si getNextFlow falló.
        return true;
    }

    return null;
  }

  resetState() {
    this.steps = [];
    this.currentStep = {} as WorkflowStep;
    this.workflow = {} as Workflow;
    this.workflows = [];
    this.requestService.categoryId = '';
  }

}
